export default "__VITE_ASSET__SrLP$fc4__"